import { Navigate, useParams, useSearch } from '@tanstack/react-router';

import { LineItemEditorPage } from '../../campaigns/campaigns/components/LineItemEditor/LineItemEditorPage/LineItemEditorPage';
import { AgencyCampaignSection, AgencyEditorMode } from '../model';
import { opensAgencyEditor } from './agencyEditorRoute';

/** Line items only exist inside a campaign editor; other states fall back to the campaign. */
export function AgencyLineItemsContent() {
  const { agencyId } = useParams({ from: '/a/$agencyId_/campaigns/$section' });
  const routeSearch = useSearch({ from: '/a/$agencyId_/campaigns/$section' });
  if (!routeSearch.campaign)
    return (
      <Navigate
        to="/a/$agencyId/campaigns/$section"
        params={{ agencyId, section: AgencyCampaignSection.Campaigns }}
        search={{}}
        replace
      />
    );
  if (opensAgencyEditor(routeSearch.editor, routeSearch.id))
    return (
      <LineItemEditorPage
        key={`${agencyId}:${routeSearch.campaign}:${routeSearch.id ?? 'new'}`}
        campaignId={routeSearch.campaign}
        lineItemId={routeSearch.editor === AgencyEditorMode.Edit ? routeSearch.id : undefined}
      />
    );
  return (
    <Navigate
      to="/a/$agencyId/campaigns/$section"
      params={{ agencyId, section: AgencyCampaignSection.Campaigns }}
      search={{ campaign: routeSearch.campaign }}
      replace
    />
  );
}
